var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tags.length > 0)?_c('div',_vm._l((_vm.tags),function(tag){return _c('el-tag',{key:tag.id,on:{"click":function($event){return _vm.goToTag(tag)}}},[_vm._v("\n    "+_vm._s(tag.name)+"\n  ")])}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }